module.exports = __webpack_public_path__ + "img/wind-01.cc0d8555.svg";